// extracted by mini-css-extract-plugin
export default {"backgroundSelectedBulk":"#FFE5A1","backgroundBulk":"#FFF4D8","borderBulk":"#FCB400"};